import * as actionTypes from './actionTypes';
import { serviceCategories } from './services';
import { actionsModalError } from '@app/src/common/modalError';

const fetchCategoriesRequest = () => ({
  type: actionTypes.FETCH_CATEGORIES_REQUEST
});

const fetchCategoriesSuccess = (data) => ({
  type: actionTypes.FETCH_CATEGORIES_SUCCESS,
  data
});

const fetchCategoriesFailure = () => ({
  type: actionTypes.FETCH_CATEGORIES_FAILURE
});

export const fetchCategories = (): Function => {
  return async dispatch => {
    dispatch(fetchCategoriesRequest());
    try {
      const data = await serviceCategories.get();
      dispatch(fetchCategoriesSuccess(data));
    } catch (e) {
      dispatch(fetchCategoriesFailure());
      dispatch(actionsModalError.openModalError());
    }
  }
}
